import React from 'react'
import { PageTitle } from '../../../../_metronic/layout/core'
import { RecordsKeeperAIOverviewBreadCrumbs } from '../core/_constants'
import { useIntl } from 'react-intl'
import { RecentUploadDataTable } from '../components/RecentUploadDataTable'

const RecentUpload = () => {
    const { formatMessage } = useIntl()
    return (
        <div>
            <PageTitle
                breadcrumbs={RecordsKeeperAIOverviewBreadCrumbs}
                description={formatMessage({ id: 'Recent Uploads' })}
            >
                {formatMessage({ id: 'RecordsKeeper AI' })}
            </PageTitle>
            <div className='px-md-6 px-3'>
                <RecentUploadDataTable />
            </div>
        </div>
    )
}

export default RecentUpload
